import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-confirm-modal',
    templateUrl: './confirm-modal.component.html',
    styles: [],
})
export class ConfirmModalComponent implements OnInit {
    constructor(public activeModal: NgbActiveModal) {}

    headerLabel: string;

    messageLabel: string;

    ngOnInit(): void {}
}
